import BaseService from "@services/BaseService";

export default class EntryService extends BaseService {
  entity = "entries";
}
